<template>
  <div>
    <ReturnHeader header="สินค้ารอคืนยังไม่ได้ทำใบ CN" :img_header="header_image" link_back="stock/storage/returnstorage"/>
    <Return_product/>
  </div>
</template>

<script>
import ImageHeader from '@/assets/file_1.png'
import ReturnHeader from "@/components/admin/stock/storage_return/header_return/ReturnHeader.vue";
import Return_product from "@/components/admin/stock/storage_return/Return_product.vue";
export default {
  name: "ReturnCN",
  components: {
    Return_product,
    ReturnHeader
  },
  data() {
    return {
      header_image: ImageHeader
    }
  }
}
</script>

<style scoped>

</style>
